import { FunctionComponent } from 'react';

import { Aside } from '@components/aside';
import { Header } from '@components/header';
import { Hero } from '@components/hero';
import { Content, Main } from '@components/main';
import { Page } from '@components/page';

interface AppProps {}

export const App: FunctionComponent<AppProps> = () => {
  return (
    <Page>
      <Header />
      <Aside />
      <Main>
        <Hero />
        <Content />
      </Main>
    </Page>
  );
};
